import React, { Component } from 'react';
import { Header, Item, Icon, Segment } from 'semantic-ui-react';

class LearnMore extends Component {
  render() {
    const { tittel, dokumenter } = this.props;
    return (
      <Segment basic>
        <Header as="h1">
          <span dangerouslySetInnerHTML={{ __html: tittel }} />
        </Header>
        <Item.Group>
          {dokumenter.map(({ navn, url, filtype }, index) => (
            <Item key={`quote-${index}`}>
              <Item.Image size="mini">
                <Icon
                  name={`file ${filtype ? filtype + ' ' : ''}outline`}
                  size="big"
                />
              </Item.Image>

              <Item.Content verticalAlign="middle">
                <Item.Header as="a" href={url} target="_blank">
                  {navn}
                </Item.Header>
              </Item.Content>
            </Item>
          ))}
        </Item.Group>
      </Segment>
    );
  }
}

export default LearnMore;



// WEBPACK FOOTER //
// ./src/LandingPage/LearnMore.js